/** Dimming for friends who can’t be challenged at the current stake (grid + row). */
export const FRIEND_SELECTOR_DISABLED_OPACITY = 0.45
